import * as React from 'react';
import { StarryUIIcon } from '../components/StarryUIIcon';

export const CheckOut = ({ color = 'currentColor', ...icon }: image.IStarryUIIcon) => (
    <StarryUIIcon {...icon}>
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M9.23263 3L15.7674 5C16.172 5 16.5 5.44772 16.5 6V9H14V16H16.5V18C16.5 18.5523 16.172 19 15.7674 19L9.23263 21C8.82801 21 8.5 20.5523 8.5 20V4C8.5 3.44772 8.82801 3 9.23263 3ZM16.5 14H16V11H16.5H18V9L22 12.5L18 16V14H16.5ZM10.5 11C9.94772 11 9.5 11.4477 9.5 12C9.5 12.5523 9.94772 13 10.5 13C11.0523 13 11.5 12.5523 11.5 12C11.5 11.4477 11.0523 11 10.5 11ZM6.5 17V19.5H3.5C2.67157 19.5 2 18.8284 2 18V17.5H4.5V17H6.5ZM2 7.65496L4.5 9.84246V15.1575L2 17.345V7.65496ZM6.5 4.5V7H4.5V7.5H2V6C2 5.17157 2.67157 4.5 3.5 4.5H6.5Z"
            fill={color}
        />
    </StarryUIIcon>
);
